export default __webpack_public_path__ + "static/media/BG-VARSKY_Desktop.b21e2a70.jpg";